import $ from 'jquery';

// npm install fitvids --save-dev
import fitvids from 'fitvids';

class Media {

    constructor() {
        this.$document = $(document);
        fitvids('.js-content-from-editor');
    }
}

export default Media;
